// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__3jTns","wrapper":"Header_wrapper__F2jW5"};